import { Button, Card, CardBody, CardHeader, Divider, Input, Spinner, Switch } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useSWR from "swr";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { getFetcher, patchFetcher } from "../../../../services/api";
import { reportDistributionValidation } from "../../../../services/validation";
import { isResponseErrorObject } from "../../../../services/helpers";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { month } from "../../../../enums/month";
import InlineEditTransporter from "../../../../components/fragments/admin/report/distribution/InlineEditTransporter";
import InlineEditCustomer from "../../../../components/fragments/admin/report/distribution/InlineEditCustomer";

export default function CreatePage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isExistReport, setIsExistReport] = useState(true);
  const { data, isLoading } = useSWR(`/api/pelaporan-bahan-b3-distribusi/find/${id}`, getFetcher);
  const {
    register,
    reset,
    control,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm({ resolver: yupResolver(reportDistributionValidation) });

  useEffect(() => {
    reset({
      laporanTersedia: setIsExistReport(data?.laporanTersedia),
      jumlahB3Distribusi: data?.jumlahB3Distribusi,
      dataTransporters: data?.DataTransporterOnPelaporanDistribusiBahanB3?.map((item) => item.dataTransporter.id),
      dataCustomers: data?.DataCustomerOnPelaporanDistribusiBahanB3?.map((item) => ({ customerId: item.dataCustomer.id, jumlahB3Distribusi: item.jumlahBahanB3Distribusi })),
    });
  }, [data, isLoading, reset]);

  function existReport(val) {
    setIsExistReport(val);
    setValue("jumlahB3Distribusi", 0);
    setValue("dataTransporters", []);
    setValue("dataCustomers", []);
  }

  async function onSubmitForm(formData) {
    try {
      const transformedData = {
        ...formData,
        jumlahB3Distribusi: Number(formData.jumlahB3Distribusi) || 0,
        dataCustomers:
          formData.dataCustomers?.map((customer) => ({
            ...customer,
            jumlahB3Distribusi: Number(customer.jumlahB3Distribusi) || 0,
          })) || [],
      };
      await patchFetcher(`/api/pelaporan-bahan-b3-distribusi/update`, id, transformedData);
      toast.success("Laporan distribusi berhasil diperbarui");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  return (
    <RootAdmin>
      <Card radius="sm" className="mt-3">
        <CardHeader>Ubah Distribusi Jenis B3 </CardHeader>
        <Divider />
        <CardBody>
          <form onSubmit={handleSubmit(onSubmitForm)}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
              <Input isRequired isDisabled label="Perusahaan" labelPlacement="outside" variant="faded" value={data?.company?.name} />
              <Input isRequired isDisabled label="Periode" labelPlacement="outside" variant="faded" value={data?.period?.name} />
              <Input isRequired isDisabled label="Bulan" labelPlacement="outside" variant="faded" value={month[data?.bulan - 1]} />
              <Input isRequired isDisabled label="Tahun" labelPlacement="outside" variant="faded" value={data?.tahun} />
              <Input isRequired isDisabled label="Jenis B3" labelPlacement="outside" variant="faded" value={`${data?.dataBahanB3?.casNumber} - ${data?.dataBahanB3?.namaBahanKimia}`} />
              <div className="col-span-2 mt-3">
                <Switch
                  {...register("laporanTersedia", {
                    onChange: (e) => {
                      existReport(e.target.checked);
                    },
                  })}
                  size="sm"
                  isSelected={isExistReport}
                >
                  {isExistReport ? "Laporan Tersedia" : "Tidak ada laporan distribusi"}
                </Switch>
              </div>
              {isExistReport && (
                <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <InlineEditTransporter control={control} setValue={setValue} selectedCompany={data?.company?.id} selectedTransporters={data?.DataTransporterOnPelaporanDistribusiBahanB3} />
                  </div>
                  <div className="col-span-2">
                    <InlineEditCustomer control={control} selectedCompany={data?.company?.id} selectedCustomers={data?.DataCustomerOnPelaporanDistribusiBahanB3} setValue={setValue} />
                  </div>
                </div>
              )}
            </div>
            <div className="flex items-center gap-1">
              <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                Tambah
              </Button>
              <Button isDisabled={isSubmitting} color="danger" variant="faded" onPress={() => navigate(-1, { replace: true })}>
                Kembali
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
